<script lang="ts">
  import { TwistGrid, TwistGridItem } from '@twist/core';
  import { BGMode } from '$components/News/Background/BackgroundGradient.svelte';
  import type { LegalCookiePage } from '$lib/sanity/schemas';
  import Container from '../News/Container.svelte';
  import LegalPageHeader from './LegalPageHeader.svelte';
  import PortableText from '$components/SanityComponents/PortableText/PortableText.svelte';
  import { useEncodeDataAttribute, type ContentSourceMap } from '@sanity/svelte-loader';
  import { sanityStudioURL } from '$lib/client';

  export let document: LegalCookiePage;
  export let sourceMap: ContentSourceMap | undefined = undefined;

  $: encodeDataAttribute = useEncodeDataAttribute(document, sourceMap, sanityStudioURL);
</script>

<LegalPageHeader title={'Cookie Policy'} bg={document.colors.primary} />
<div
  data-background
  data-bgmode={BGMode.DOUBLE}
  data-bgcolor1={document.colors.primary}
  data-bgcolor2={document.colors.secondary}
>
  <Container>
    <TwistGrid>
      <TwistGridItem colSpan={{ min: 4, lg: 9 }} colStart={{ min: 1, lg: 3 }} rowStart={1}>
        {#if document.pageContent}
          <div data-sanity={encodeDataAttribute(['pageContent'])}>
            <PortableText body={document.pageContent} />
          </div>
        {/if}
      </TwistGridItem>
    </TwistGrid>
  </Container>
</div>
